export const INVOICES_REPORT_ID = 'invoices';
